import { useState, useEffect } from 'react';
import { JsonToTable } from 'react-json-to-table';
import * as R from 'ramda';
import { getCourses, _getTotalReport} from '../../../util/api';
import LoadingModal from '../../dumb/LoadingModal'
import DateSelector from '../../dumb/form/DateSelector';
import ActionTable from '../../dumb/ActionTable';

const Counsellors = [
  {
    key: 'noone@email.com',
    display: 'Please Select Email'
  },
  {
    key: 'somasree@prepfortech.in',
    display: 'Somasree'
  },
  {
    key: 'vidhi@prepfortech.in',
    display: 'Vidhi Trivedi'
  }
];

function TotalReportComponent() {

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('Not Selected');
  const [error, setError] = useState(undefined);
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [totalReport, setTotalReport] = useState(undefined);

  return (
    <div>
      {
        !R.isNil(error) && (
          <div style={{ color: 'red' }}> { error } </div>
        )
      }
      <div className={"form-group"}>
        <label> Select Counsellor </label>
        <select
        onChange={(e) => {
          setEmail(e.currentTarget.value);
        }}>
          {
            Counsellors.map(counsellor => (
              <option key={counsellor.key} value={counsellor.key}> { counsellor.display } </option>
            ))
          }
        </select>
      </div>
      <div className={"form-group"}>
        <label> Select Start Date </label>
        <DateSelector selectDate={startDate => setStartDate(startDate)} />
      </div>
      <div className={"form-group"}>
        <label> Select End Date </label>
        <DateSelector selectDate={endDate => setEndDate(endDate)} />
      </div>
      <button
        class="btn btn-primary"
        onClick={() => {
          setLoading(true);
          _getTotalReport(email, startDate, endDate)
            .then(report => {
              report.summary.minEnquiryTime = new Date(report.summary.minEnquiryTime*1000).toLocaleString();
              report.summary.maxEnquiryTime = new Date(report.summary.maxEnquiryTime*1000).toLocaleString();
              setTotalReport(report);
              setLoading(false);
            })
            .catch(error => {
              console.error(error);
              setError(`${JSON.stringify(error)}`);
              setLoading(false);
            });
        }}
      >
        Get Report
      </button>
      {
        !R.isNil(totalReport) && (
          <>
            <JsonToTable json={totalReport.summary} />
            <ActionTable data={totalReport.actions} />
          </>
        )
      }
      {
        loading && (
          <LoadingModal />
        )
      }
    </div>
  );
}

export default TotalReportComponent;
